import React, { useEffect } from "react";
import { LuPlus } from "react-icons/lu";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLazyGetalldocappointmentsQuery } from "../../State/Api/AdddocApiSlice";

const PatientAppointments = ({doctorViewData,doctorUserUniqueID }) => {
  const navigate=useNavigate();
  const clinicUserId = localStorage.getItem("userClinicID");
  const location=useLocation();
  const [
    fetchClinicAppointments,
    { data: clinicappointmentData = [], isFetching },
  ] = useLazyGetalldocappointmentsQuery();

  useEffect(() => {
    if (clinicUserId && doctorUserUniqueID) {
      fetchClinicAppointments({ clinicUserId, doctorUserUniqueID });
    }
  }, [clinicUserId, doctorUserUniqueID]);

  return (
    <div className="mt-2 space-y-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
      <div className="rounded-lg border bg-white shadow-sm">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4">
          <div>
            <h2 className="text-xl xl:text-2xl font-semibold mb-2 tracking-tight">
              Appointment History
            </h2>
            <div className="text-sm text-gray-500">
              View all appointments and medical visits.
            </div>
          </div>
          <button onClick={()=>{navigate("/AddAppointment", { state: { showModal: true, doctorName:doctorViewData?.basicinfo?.fullname,doctorSpecialization:doctorViewData?.professionalinfo?.specialization,fromDoctorView: true,from: location.pathname } })}} className="inline-flex items-center gap-2 rounded-md text-sm font-medium bg-[#171717] text-white hover:bg-[#2e2e2e] h-10 px-4 py-2 gradient-button">
            <LuPlus className="h-4 w-4" /> Schedule Appointment
          </button>
        </div>

        {/* Scrollable Table Container */}
        <div className="p-4">
          <div className="relative max-h-96 overflow-y-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left text-gray-500">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0 z-10">
                <tr>
                  <th scope="col" className="px-6 py-3 bg-gray-50">
                    Date & Time
                  </th>
                  <th scope="col" className="px-6 py-3 bg-gray-50">
                    Type
                  </th>
                  <th scope="col" className="px-6 py-3 bg-gray-50">
                    Patient
                  </th>
                  <th scope="col" className="px-6 py-3 bg-gray-50">
                    Gender
                  </th>
                  <th scope="col" className="px-6 py-3 bg-gray-50">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(clinicappointmentData) &&
                  clinicappointmentData.map((appointment, index) => (
                    <tr key={appointment.id || index} className="odd:bg-white even:bg-gray-50 border-b">
                      <td className="px-6 py-4">
                        <p>
                          {appointment?.appointmentDate
                            ? new Date(appointment.appointmentDate)
                                .toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                                .replace(/ /g, "-")
                            : "N/A"}
                        </p>
                        <p className="text-sm text-gray-500">
                          {appointment?.timeSlot}
                        </p>
                      </td>
                      <td className="px-6 py-4">{appointment?.visitType}</td>
                      <td className="px-6 py-4">{appointment?.patientName}</td>
                      <td className="px-6 py-4 max-w-[200px] truncate">
                        {appointment?.gender}
                      </td>
                      <td className="px-6 py-4">
                        <span
                          className={`inline-flex items-center rounded-full text-white px-2.5 py-0.5 text-xs font-semibold
                            ${
                              appointment?.status === "Upcoming"
                                ? "bg-yellow-500"
                                : appointment?.status === "Today"
                                ? "bg-orange-500"
                                : appointment?.status === "Completed"
                                ? "bg-green-500"
                                : appointment?.status === "Cancelled" ? "bg-red-500" : "bg-gray-500"
                            }
                          `}
                        >
                          {appointment?.status}
                        </span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            
            {/* Loading indicator */}
            {isFetching && (
              <div className="flex justify-center items-center py-4">
                <div className="text-gray-500">Loading appointments...</div>
              </div>
            )}
            
            {/* Empty state */}
            {!isFetching && (!clinicappointmentData || clinicappointmentData.length === 0) && (
              <div className="flex justify-center items-center py-8 text-gray-500">
                No appointments found
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientAppointments;
